"use client";

import { useState } from "react";
import { CASE_STUDIES, CASE_STUDY_CATEGORIES, type CaseStudyCategory } from "@/lib/data/case-studies";
import CaseStudyCard from "./CaseStudyCard";

type Filter = "All" | CaseStudyCategory;

const FILTERS: readonly Filter[] = ["All", ...CASE_STUDY_CATEGORIES];

/** Category tabs over the case-study grid. The categories mirror the navbar's Solutions menu. */
export default function CaseStudiesBrowser() {
  const [filter, setFilter] = useState<Filter>("All");
  const visible = filter === "All" ? CASE_STUDIES : CASE_STUDIES.filter((study) => study.category === filter);

  return (
    <div>
      <div role="group" aria-label="Filter case studies by solution" className="flex flex-wrap gap-size-sm mb-size-lg">
        {FILTERS.map((option) => {
          const active = option === filter;
          return (
            <button
              key={option}
              type="button"
              aria-pressed={active}
              onClick={() => setFilter(option)}
              className={`rounded-full px-size-md py-2 font-label-md text-label-md font-bold transition-colors ${
                active
                  ? "bg-mkt-primary-container text-mkt-on-primary"
                  : "border border-mkt-primary/30 bg-white text-mkt-primary hover:bg-mkt-primary-container/10"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>

      <ul className="list-none pl-0 ml-0 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-gutter">
        {visible.map((study) => (
          <li key={study.slug}>
            <CaseStudyCard study={study} />
          </li>
        ))}
      </ul>
    </div>
  );
}
